import { defineMessages } from 'react-intl';

export const NUM_LOCATIONS_TO_SHOW_ON_PAGE_LOAD = 4;

export const BOOKING_SECTION_KEY = '@@bookSection';

export const PADDING_X_XXSMALL = 16;
export const PADDING_X_MEDIUM = 30;
export const PADDING_X_LARGE = 44;

export const LOCALIZED_STRINGS = defineMessages({
    BookingSectionButtonText: {
        id: 'Profile.Components.BookingSectionButton.ButtonText',
        defaultMessage: 'Book an appointment',
    },
    BookingSectionHeader: {
        id: 'Profile.Components.BookingSection.Header',
        defaultMessage: 'Book an appointment for free',
    },
    ProcedureDropdownLabel: {
        id: 'Profile.Components.BookingSection.ProcedureDropdownLabel',
        defaultMessage: 'Reason for your visit',
    },
    ProcedureDropdownLabel1Z: {
        id: 'Profile.Components.BookingSection.ProcedureDropdownLabel1Z',
        defaultMessage: 'What\'s the reason for your visit?',
    },
    NewExistingRadioLabel: {
        id: 'Profile.Components.BookingSection.NewExistingRadioLabel',
        defaultMessage: 'Have you seen {name} before?',
    },
    NewExistingRadioLabelV2: {
        id: 'Profile.Components.BookingSection.NewExistingRadioLabel1Z',
        defaultMessage: 'Has the patient seen this {profileType} before?',
    },
    NewExistingRadioLabelV2Mobile: {
        id: 'Profile.Components.BookingSection.NewExistingRadioLabel1ZMobile',
        defaultMessage: 'Seen this {profileType} before?',
    },
    NewExistingRadioTextExisting: {
        id: 'Profile.Components.BookingSection.NewExistingRadioLabel1Z.ExistingText',
        defaultMessage: 'Yes',
    },
    NewExistingRadioTextNew: {
        id: 'Profile.Components.BookingSection.NewExistingRadioLabel1Z.NewText',
        defaultMessage: 'No',
    },
    InsuranceAccepted: {
        id: 'Profile.Components.BookingSection.InsuranceAccepted',
        defaultMessage: 'Your insurance is accepted here',
    },
    InsuranceNotAccepted: {
        id: 'Profile.Components.BookingSection.InsuranceAccepted',
        defaultMessage: 'Your insurance is not accepted here',
    },
    InsurancePickerLabel: {
        id: 'Profile.Components.BookingSection.InsurancePickerLabel',
        defaultMessage: 'Insurance',
    },
    LocationCarouselLabel: {
        id: 'Profile.Components.BookingSection.LocationCarouselLabel',
        defaultMessage: 'Office location',
    },
    LocationAppointmentPickersLabel: {
        id: 'Profile.Components.BookingSection.LocationAppointmentPickersLabel',
        defaultMessage: 'Select a time at an office location',
    },
    SeeAllLocations: {
        id: 'Profile.Components.BookingSection.SeeAllLocations',
        defaultMessage: 'See all {numberOfLocations} locations',
    },
    TimesGridLabel: {
        id: 'Profile.Components.BookingSection.TimesGridLabel',
        defaultMessage: 'Date and time',
    },
});
